import React from "react";

interface CallViewsEmptyStateProps {
  onChangeDateRange?: () => void;
}

/**
 * Distinguishes "no data because tracking is brand new / feature flag off"
 * from "nobody viewed in this range". Web/api collection starts at rollout,
 * so an empty range may simply mean tracking has not gathered data yet.
 */
export const CallViewsEmptyState: React.FC<CallViewsEmptyStateProps> = ({
  onChangeDateRange,
}) => {
  return (
    <div
      className="bg-white rounded-lg border border-neutral-200 p-8 text-center"
      data-testid="call-views-empty-state"
    >
      <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-neutral-100 mb-4">
        <svg
          className="w-6 h-6 text-neutral-400"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          />
        </svg>
      </div>

      <h3 className="text-lg font-semibold text-neutral-900 mb-2">
        Brak odsłon w wybranym zakresie
      </h3>

      <p className="text-neutral-600 max-w-md mx-auto">
        Dla wybranego zakresu dat nikt nie przeglądał naborów — albo śledzenie
        odsłon dopiero wystartowało (dane web/api zbierane od dnia wdrożenia) lub
        jest wyłączone. Spróbuj zmienić zakres dat.
      </p>

      {onChangeDateRange && (
        <button
          onClick={onChangeDateRange}
          aria-label="Zmień zakres dat"
          className="mt-4 px-4 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700 focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2"
        >
          Zmień zakres dat
        </button>
      )}
    </div>
  );
};

export default CallViewsEmptyState;
